<template>
  <div
    ref="perfectScrollbarRef"
    :style="{ width: width, height: height }"
    class="perfect-scrollbar-container"
  >
    <slot name="container"></slot>
  </div>
</template>

<script>
import PerfectScrollbar from "perfect-scrollbar";
import { onMounted, onBeforeUnmount, ref } from "vue";

export default {
  props: {
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const perfectScrollbarRef = ref(null);
    const ps = ref(null);

    const init = () => {
      ps.value = new PerfectScrollbar(perfectScrollbarRef.value);
    };

    const setScrollTop = (value) => {
      const dom = perfectScrollbarRef.value;
      dom.scrollTop = value;
    };

    const setScrollLeft = (value) => {
      const dom = perfectScrollbarRef.value;
      dom.scrollLeft = value;
    };

    const update = () => {
      ps.value.update();
    };

    const destory = () => {
      ps.value.destory();
      ps.value = null;
    };

    onMounted(() => {
      init();
    });

    onBeforeUnmount(() => {
      destory();
    });

    return {
      perfectScrollbarRef,
      setScrollTop,
      setScrollLeft,
      update,
      destory,
    };
  },
};
</script>

<style lang="less" scoped>
.perfect-scrollbar-container {
  position: relative;
}
</style>
